'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _loginForm = require('./login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogInModal = function (_Component) {
    _inherits(LogInModal, _Component);

    function LogInModal(props) {
        _classCallCheck(this, LogInModal);

        var _this = _possibleConstructorReturn(this, (LogInModal.__proto__ || Object.getPrototypeOf(LogInModal)).call(this, props));

        _this.state = {
            'password': '',
            'emailAddress': _this.props.emailAddress,
            'isProcessing': false
        };
        return _this;
    }

    _createClass(LogInModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.isInline && this.isFoundationFriendly()) {
                $(document).foundation();
                $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.isInline && this.isFoundationFriendly()) {
                $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
            }
        }

        // Note: version 1.4.4 of jQuery is incompatible with Foundation.

    }, {
        key: 'isFoundationFriendly',
        value: function isFoundationFriendly() {
            return window.$ && $.fn.jquery !== '1.4.4';
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var loginFormProps = {
                header: props.header,
                buttonText: props.buttonText,
                isInline: props.isInline,
                inlineSideText: props.inlineSideText,
                googleOpenIdUrl: props.googleOpenIdUrl,
                redirectUrl: props.redirectUrl,
                recaptchaPublicKey: props.recaptchaPublicKey,
                displayCaptcha: props.displayCaptcha,
                isFromApiPricing: props.isFromApiPricing,
                planId: props.planId,
                tabOffset: props.tabOffset,
                emailAddress: props.emailAddress,
                recoverPasswordForm: props.recoverPasswordForm,
                action: props.loginUrl,
                fields: props.loginForm.fields,
                values: props.loginForm.values,
                namespace: props.loginForm.namespace,
                hideRememberMe: props.hideRememberMe,
                hideGoogleOpenId: props.hideGoogleOpenId
            };

            return _react2['default'].createElement(_loginForm2['default'], loginFormProps);
        }
    }]);

    return LogInModal;
}(_react.Component);

LogInModal.propTypes = {
    'header': _react.PropTypes.string.isRequired,
    'googleOpenIdUrl': _react.PropTypes.string,
    'tabOffset': _react.PropTypes.number,
    'emailAddress': _react.PropTypes.string,
    'loginUrl': _react.PropTypes.string,
    'recaptchaPublicKey': _react.PropTypes.string,
    'displayCaptcha': _react.PropTypes.bool,
    'recoverPasswordForm': _react.PropTypes.object.isRequired, // Serialized sfForm
    'loginForm': _react.PropTypes.object.isRequired, // Serialized sfForm
    'redirectUrl': _react.PropTypes.string,
    'hideRememberMe': _react.PropTypes.bool,
    'hideGoogleOpenId': _react.PropTypes.bool
};


module.exports = LogInModal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-modal.jsx
 ** module id = 876
 ** module chunks = 0
 **/